
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const SplashPage = lazy(() => import('../pages/splash/page'));
const AuthPage = lazy(() => import('../pages/auth/page'));
const EligibilityPage = lazy(() => import('../pages/eligibility/page'));
const HomePage = lazy(() => import('../pages/home/page'));
const CategoriesPage = lazy(() => import('../pages/categories/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const OrderTrackingPage = lazy(() => import('../pages/order-tracking/page'));
const OrdersPage = lazy(() => import('../pages/orders/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <SplashPage />
  },
  {
    path: '/auth',
    element: <AuthPage />
  },
  {
    path: '/eligibility',
    element: <EligibilityPage />
  },
  {
    path: '/home',
    element: <HomePage />
  },
  {
    path: '/categories',
    element: <CategoriesPage />
  },
  {
    path: '/cart',
    element: <CartPage />
  },
  {
    path: '/checkout',
    element: <CheckoutPage />
  },
  {
    path: '/order-tracking',
    element: <OrderTrackingPage />
  },
  {
    path: '/orders',
    element: <OrdersPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
